import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Clock, XCircle, Loader2 } from "lucide-react";

export default function CheckoutResult({ kind }) {
  const [state, setState] = useState({ loading: true, status: kind });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentId = params.get("payment_id") || params.get("collection_id");
    if (kind === "success" && paymentId) {
      api
        .post("/checkout/confirm", { payment_id: paymentId })
        .then((r) => setState({ loading: false, status: r.data.order_status === "paid" ? "success" : r.data.order_status }))
        .catch(() => setState({ loading: false, status: "success" }));
    } else {
      setState({ loading: false, status: kind });
    }
  }, [kind]);

  const map = {
    success: [CheckCircle2, "text-emerald-500", "Pagamento aprovado!", "Seus créditos já estão disponíveis no painel. Publique sua vaga agora."],
    pending: [Clock, "text-amber-500", "Pagamento pendente", "Assim que o pagamento for confirmado, seus créditos serão liberados automaticamente."],
    failure: [XCircle, "text-red-500", "Pagamento não concluído", "O pagamento não foi finalizado. Você pode tentar novamente."],
  };
  const [Icon, color, title, desc] = map[state.status] || map.pending;

  if (state.loading)
    return (
      <div className="flex justify-center py-32 text-slate-500"><Loader2 className="animate-spin" size={32} /></div>
    );

  return (
    <div className="max-w-lg mx-auto px-5 py-24 text-center" data-testid="checkout-result">
      <Icon size={64} className={`mx-auto ${color}`} />
      <h1 className="font-heading text-3xl font-extrabold tracking-tight mt-6 text-slate-950">{title}</h1>
      <p className="text-slate-600 mt-3 leading-relaxed">{desc}</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/empresa" className="bg-slate-950 text-white font-bold px-5 py-3 rounded-xl hover:bg-slate-800">Ir ao painel</Link>
        <Link to="/planos" className="bg-white border border-slate-200 font-bold px-5 py-3 rounded-xl hover:bg-slate-50">Ver planos</Link>
      </div>
    </div>
  );
}
